import React from 'react';
import { Helmet } from 'react-helmet';
import { HomieHero, HomieStores, HomieProducts, HomieSustainability, HomieMarquee } from '../components/homie/index.ts';

const HomiePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sweetspot Cannabis Dispensary: Home</title>
        <meta name="description" content="Shop medical and recreational marijuana, pre-rolls, edibles, and more across CT, MD, NJ, RI, and VT." />
        <meta name="keywords" content="cannabis dispensary, marijuana dispensary, medical cannabis, recreational marijuana, cannabis products, Sweetspot Cannabis" />
        <meta property="og:title" content="Sweetspot Cannabis Dispensary: Home" />
        <meta property="og:description" content="Your premier destination for premium cannabis products. Medical and recreational dispensaries across multiple states." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sweetspotfarms.com" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://sweetspotfarms.com/" />
      </Helmet>
      <HomieHero />
      <div className="content-below-hero">
        <HomieMarquee />
        <HomieStores />
        <HomieProducts />
        <HomieSustainability />
      </div>
    </>
  );
};

export default HomiePage;
